export default "__VITE_ASSET__BS0ER66j__"